import React from "react";

import FooterLogo from "./FooterLogo";

const DefaultFooterLogo = () => {
  const width = global.isDesktop ? "200" : "180";
  const height = global.isDesktop ? "27" : "24.3";

  return <FooterLogo width={width} height={height} />;
};

export default DefaultFooterLogo;
